import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

export const resetOnContextChange = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: ({ editingFunctionalUsage }: State) => ({
        ...State.INITIAL,
        editingFunctionalUsage,
      }),
    }),
)
